import { Injectable } from '@angular/core';
import { PiramidalService } from './piramidal.service';
import { map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrandsService {
  public readonly brands$ = this._piramidalService.brands.observable.pipe(shareReplay());
  public readonly brandsIdx$ = this.brands$.pipe(
    map((brands) =>
      brands.reduce((idx, b) => {
        idx[b.id] = b;
        return idx;
      }, {}),
    ),
    shareReplay(),
  );

  constructor(private _piramidalService: PiramidalService) {}
}
